<template>
    <div
        class="custom-create-form-wrapper"
        id="parent-register-form"
        v-if="currentPage">
        <div class="custom-create-form">
            <custom-form-create-header-component
                :title="customFormIn.name"
                logo="/images/amsterdams-lyceum-logo.png"
                bg-color="#0062ab"
                title-color="#fff">
            </custom-form-create-header-component>
        </div>

        <div class="custom-form-create-body">
            <custom-form-create-page-component
                :questions-in="currentPageQuestions"
                :page-title="currentPage.title"
                :previous-button="currentPageNumber !== 1"
                :next-button="currentPageNumber !== customFormIn.pages.length"
                :submit-button="currentPageNumber === customFormIn.pages.length"
                @update-answer="updateAnswer($event)"
                @previous-page="previousPage"
                @next-page="nextPage"
                @submit-form="save">
            </custom-form-create-page-component>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import { ords } from '../../../../app';
import { routes } from '../../../../helpers/routes';

export default {
    name: 'custom-form-create-component',
    props: {
        customFormIn: Object,
        hashIn: String,
    },
    data() {
        return {
            currentPageNumber: 1,
            answers: [],
            currentPage: null,
            currentPageQuestions: [],
            triedToSave: false,
            triedToNext: false,
        };
    },
    methods: {
        updateAnswer(answer) {
            if (this.answers.find((currentAnswer) => currentAnswer.questionId === answer.questionId)) {
                this.answers = this.answers.map((currentAnswer) => {
                    return currentAnswer.questionId === answer.questionId ? answer : currentAnswer;
                });
            } else {
                this.answers.push(answer);
            }
        },
        save() {
            if (this.formHasErrors()) {
                this.triedToSave = true;
                this.setCurrentPageQuestions();
                this.alert.warning(this.$t('common.form_not_complete_not_all_required_fields_have_been_completed'));
                return;
            }

            let data = {
                answers: this.answers.map((answer) => {
                    let value = answer.value;
                    if (answer.type === 4 && !Array.isArray(answer.value)) {
                        value = [answer.value];
                    }
                    if (answer.type === 5) {
                        value = answer.value.data;
                    }

                    return {
                        questionId: answer.questionId,
                        value: value,
                    };
                }),
                hash: this.hashIn,
            };

            this.alert.saving();
            this.axios.post(this.routes.customFormSubmit(this.customFormIn.id), data).then(
                (response) => {
                    this.alert.success();
                    window.location.href = this.routes.baseUrl() + this.routes.customFormFinished();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        formHasErrors() {
            for (const page of this.customFormIn.pages) {
                for (const question of page.questions) {
                    const answer = this.answers.find((a) => a.questionId === question.id);

                    // todo what you actually want is that the answers has a .hasError() function, you would determine
                    // todo when creating/updating the answer.

                    // required but empty
                    if (question.required && (!answer || answer.isEmpty)) {
                        return true;
                    }
                    // not required and empty
                    if (!question.required && (!answer || answer.isEmpty)) {
                        continue;
                    }

                    // todo for now secured is only used for bsn, in the future you might want to give bsn its own type
                    if (
                        question.secured &&
                        (answer.value.length < 8 || answer.value.length > 9 || !/^\d+$/.test(answer.value))
                    ) {
                        return true;
                    }

                    // email
                    if (question.type === 6) {
                        const regex = new RegExp('[a-z0-9]+@[a-z]+\.[a-z]{2,3}');
                        if (!regex.test(answer.value)) {
                            return true;
                        }
                    }
                }
            }
        },

        pageHasErrors() {
            const page = this.customFormIn.pages.find((page) => {
                return page.order === this.currentPageNumber;
            });

            for (const question of page.questions) {
                const answer = this.answers.find((a) => a.questionId === question.id);

                // todo what you actually want is that the answers has a .hasError() function, you would determine
                // todo when creating/updating the answer.

                // required but empty
                if (question.required && (!answer || answer.isEmpty)) {
                    return true;
                }
                // not required and empty
                if (!question.required && (!answer || answer.isEmpty)) {
                    continue;
                }

                // todo for now secured is only used for bsn, in the future you might want to give bsn its own type
                if (
                    question.secured &&
                    (answer.value.length < 8 || answer.value.length > 9 || !/^\d+$/.test(answer.value))
                ) {
                    return true;
                }

                // email
                if (question.type === 6) {
                    const regex = new RegExp('[a-z0-9]+@[a-z]+\.[a-z]{2,3}');
                    if (!regex.test(answer.value)) {
                        return true;
                    }
                }
            }
        },

        nextPage() {
            if (!this.triedToNext || this.triedToNext < this.currentPageNumber) {
                this.triedToNext = this.currentPageNumber;
            }

            if (this.pageHasErrors()) {
                this.setCurrentPageQuestions();
                this.alert.warning(this.$t('common.form_not_complete_not_all_required_fields_have_been_completed'));
                return;
            }

            this.currentPageNumber++;
            this.setCurrentPage();
            $('.main-content').animate({ scrollTop: 0 }, 500);
        },
        previousPage() {
            this.currentPageNumber--;
            this.setCurrentPage();
        },
        setCurrentPage() {
            this.currentPage = this.customFormIn.pages.find((page) => page.order === this.currentPageNumber);
            this.setCurrentPageQuestions();
        },
        setCurrentPageQuestions() {
            this.currentPageQuestions = this.currentPage.questions.map((question) => {
                const answer = this.answers.find((answer) => answer.questionId === question.id);
                let hasError = false;
                let errorText = '';

                const shouldCheckForErrors = this.triedToSave || this.triedToNext >= this.currentPageNumber;

                const questionNeedsToBeCheckedForErrors = question.required && (!answer || answer.isEmpty);
                const bsnQuestionValidate =
                    !answer ||
                    answer.isEmpty ||
                    (answer && answer.value.length < 8) ||
                    (answer && answer.value.length > 9) ||
                    (answer && answer.value.length === 8) ||
                    (answer && answer.value.length === 9 && /^\d+$/.test(answer.value) === false);
                const regex = new RegExp('[a-z0-9]+@[a-z]+\.[a-z]{2,3}');
                const emailQuestionTypeValidate = answer && !regex.test(answer.value);

                if (shouldCheckForErrors && questionNeedsToBeCheckedForErrors) {
                    hasError = true;
                    errorText = this.$t('common.this_is_a_required_field');
                }

                if (shouldCheckForErrors && bsnQuestionValidate && question.secured) {
                    hasError = true;
                    errorText = this.$t('custom_form.bsn_must_be_a_series_of_8_or_9_numbers');
                }

                if (shouldCheckForErrors && emailQuestionTypeValidate && question.type === 6) {
                    hasError = true;
                    errorText = this.$t('common.enter_a_valid_email_address_here');
                }

                return {
                    model: question,
                    answer: answer ? answer.value : null,
                    hasError: hasError,
                    errorText: errorText,
                };
            });
        },
    },
    mounted() {
        this.setCurrentPage();
    },
};
</script>

<style scoped lang="scss">
.custom-form-create-body {
    padding: map-get($grid-gutter-spacing, 'twenty-one');
}
</style>
